import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

// Store pro sekci "Další grafy" (produkty dalsi-tsranorm / dalsi-sranorm).
// Sdílený mezi oběma produkty (chip období bývá stejný). Rok NENÍ zde —
// bere se z useYearPeriodStore (sdílený se všemi DlyOneYear*View).
// Viz doc/plans/chart-tsra-norm-client.md.
export const useDalsiGrafStore = create(
  persist(
    set => ({
      chip: 'ROK',           // ROK | Q1..Q4 | JARO | LETO | PODZIM | ZIMA
      activeTab: 'graf',     // graf | data
      chartFormat: 'png',    // png | jpg | svg
      interactive: false,

      setChip: chip => set({ chip }),
      setActiveTab: activeTab => set({ activeTab }),
      setChartFormat: chartFormat => set({ chartFormat }),
      setInteractive: interactive => set({ interactive }),
    }),
    {
      name: 'dalsi-graf-store',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
)
